import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-sparkling-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white">17吃瓜网</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注娱乐八卦、明星动态、热门瓜料的资讯聚合平台。每日更新最新吃瓜内容，带你第一时间吃到最劲爆的瓜。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              <a href="#footer-categories" className="text-white no-underline">热门分类</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              <a href="#footer-links" className="text-white no-underline">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">关于我们</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">联系我们</Link>
              <a href="#privacy" className="text-sm text-foreground-300 hover:text-white transition-colors">隐私政策</a>
              <a href="#terms" className="text-sm text-foreground-300 hover:text-white transition-colors">用户协议</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              <a href="#footer-contact" className="text-white no-underline">关注我们</a>
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="mailto:contact@17chigua.com" className="text-sm text-foreground-300 hover:text-white transition-colors flex items-center gap-2">
                <i className="ri-mail-line"></i> contact@17chigua.com
              </a>
              <a href="#weibo" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-white transition-colors flex items-center gap-2">
                <i className="ri-weibo-line"></i> 新浪微博
              </a>
              <a href="#wechat" target="_blank" rel="nofollow noopener" className="text-sm text-foreground-300 hover:text-white transition-colors flex items-center gap-2">
                <i className="ri-wechat-line"></i> 微信公众号
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 17吃瓜网 - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-400 hover:text-white transition-colors">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-400 hover:text-white transition-colors">用户协议</a>
            <a href="#sitemap" className="text-xs text-foreground-400 hover:text-white transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}